
// ------------------ LOAD CART ------------------
// function load_cart() {
  
//   fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
//     .then((response) => response.text())
//     .then((responseText) => {
//       const cartid = 'cart-drawer';
//       const html = new DOMParser().parseFromString(responseText, 'text/html');
//       const destination = document.querySelector('.cart-sidebar');
//       const source = html.getElementById(cartid);

//       if (source && destination) destination.innerHTML = source.innerHTML;

//       // ------------------ REMOVE ITEM ------------------
//       document.querySelectorAll('.item-remove').forEach(function (cartRemove) {
//         const data_line = cartRemove.dataset.line;
//         cartRemove.addEventListener('click', () => {
//           removeItem(data_line);
//           console.log("------------");
//           setTimeout(() => {
//            const upsellWrap = document.querySelector('.cart-upsell-wrap');
//             console.log(upsellWrap,"upsellWrap---");
//             if (upsellWrap) {
//               console.log("iffffffffff");
//               upsellWrap.style.opacity = '1';
//             }
//           }, 2000);
          
//         });
//       });

//       // ------------------ INIT SWIPERS ------------------
//       if (window.innerWidth > 767) {
//         initCartSliders();
//       } else {
//         // initSearchRowSwipers();
//       }
//       initCartmbUpsell();

//       // ------------------ DRAWER MIDDLE & EMPTY ------------------
//       const drawerMiddle = document.querySelector('.cart-sidebar .drawer-middle');
//       const drawerfooter = document.querySelector('.cart-sidebar .drawer-footer');
//       const emptyDiv = document.querySelector('.cart-sidebar .empty-cart');
//       const cartItems = document.querySelectorAll('.cart-sidebar .cartitems');
//       if (drawerMiddle) drawerMiddle.style.opacity = cartItems.length > 0 ? '1' : '0';
//       if (drawerfooter) drawerfooter.style.opacity = cartItems.length > 0 ? '1' : '0';
//       if (emptyDiv) emptyDiv.style.opacity = cartItems.length > 0 ? '0' : '1';


//       document.querySelectorAll('.cart-discount-btn').forEach(btn => {
//         btn.addEventListener('click', () => {
//           const parent = btn.closest('.dr-stack-cart');
//           if (parent) {
//             parent.classList.toggle('active'); 
            
//           }
//         });
//       });

//       // ------------------ HEADER CART CLICK ------------------
//       document.querySelectorAll('.header-cart').forEach((cartButton) => {
//         cartButton.addEventListener('click', function () {
//           const body = document.querySelector('body');
//           const cartDrawer = document.querySelector('.cart-sidebar');
//           const upsellWrap = document.querySelector('.cart-upsell-wrap');
//           const drawerfooter = document.querySelector('.cart-sidebar .drawer-footer');
//           const drawermiddle = document.querySelector('.cart-sidebar .drawer-middle');

//           body.classList.add('open-drawer');
//           body.classList.remove('open-menu', 'open-search', 'open-sort', 'open-filter');
//           lenis.stop();

//           initCartmbUpsell();
//           if (window.innerWidth > 767) initCartSliders();

//           if (cartDrawer) {
//             if (window.innerWidth > 767) {
//               cartDrawer.style.maxHeight = window.innerHeight + 'px';
//               cartDrawer.style.opacity = '1';
//               cartDrawer.addEventListener('transitionend', function handler(ev) {
//                 if (ev.propertyName === 'max-height') {
//                   if (upsellWrap) upsellWrap.style.opacity = '1';
//                   if (drawerfooter) drawerfooter.style.opacity = '1';
//                   if (drawermiddle) drawermiddle.style.opacity = '1';
//                   cartDrawer.removeEventListener('transitionend', handler);
//                 }
//               });
//             } else {              
//               //  initSearchRowSwipers();
//               if (upsellWrap) {
//                 upsellWrap.style.opacity = '1';
                
//               }
//             }
//           }
//         });
//       });

//       document.querySelectorAll('.overlay-box,.cart-drawer-close').forEach((closeButton) => {
//         closeButton.addEventListener('click', function () {
//           const body = document.querySelector('body');
//           const cartDrawer = document.querySelector('.cart-sidebar');
//           const upsellWrap = document.querySelector('.cart-upsell-wrap');
//           const drawerfooter = document.querySelector('.cart-sidebar .drawer-footer');
//           const drawermiddle = document.querySelector('.cart-sidebar .drawer-middle');

//           body.classList.remove('open-drawer', 'open-menu', 'open-search', 'open-sort', 'open-filter');

//           if (upsellWrap){
//               upsellWrap.style.opacity = '0';
//           } 

//           lenis.start();

//           if (window.innerWidth > 767 && cartDrawer) {
//             cartDrawer.style.maxHeight = '0px';
//             cartDrawer.style.opacity = '0';
//             if (drawerfooter) drawerfooter.style.opacity = '0';
//             if (drawermiddle) drawermiddle.style.opacity = '0';

//             cartDrawer.addEventListener('transitionend', function handler() {
//               cartDrawer.style.maxHeight = '';
//               cartDrawer.style.opacity = '';
//               cartDrawer.removeEventListener('transitionend', handler);
//             });
//           }
//         });
//       });

//       // ------------------ CART VARIANTS ------------------
//       cartVariant();

//       // ------------------ UPDATE CART COUNT ------------------
//       fetch('/cart.js')
//         .then((resp) => resp.json())
//         .then((data) => {
//           document.querySelector('.cart-count').innerHTML = data.item_count;
//         })
//         .catch((error) => console.log(error));
//     });
//     // ------------------ Threshold free product ------------------
//     const cartForm = document.querySelector('.cart-iems-wrap [data-free-product]');

//     if (cartForm) {

//       const threshold = Number(cartForm.dataset.freeThreshold || 0);
//       const freeProduct = Number(cartForm.dataset.freeProduct || 0);

//       if (!freeProduct || !threshold) return;

//       fetch('/cart.js')
//         .then(res => res.json())
//         .then(cart => {

//           const total = cart.items_subtotal_price / 100;
//           const freeItem = cart.items.find(i => i.id == freeProduct);


//           if (total >= threshold && !freeItem) {

//             fetch('/cart/add.js', {
//               method: 'POST',
//               headers: { 'Content-Type': 'application/json' },
//               body: JSON.stringify({
//                 id: freeProduct,
//                 quantity: 1
//               })
//             })
//             .then(r => r.json())
//             .then(() => {
//               load_cart();
//             });
//             return;
//           }

//           if (total < threshold && freeItem) {

//             const removeBtn = document.querySelector(`.item-remove[data-line="${freeProduct}"]`);
//             console.log(removeBtn);
//             if (removeBtn) {
//               removeItem(removeBtn.dataset.line);
//             }
//           }

//         });
//     }

//     // ------------------ Buy x get y ------------------
//     const newCart = document.querySelector('#cart');

//     if (newCart) {

//       const buyIds = (newCart.dataset.buyId || '')
//         .split(',')
//         .map(id => Number(id.trim()))
//         .filter(id => id > 0);

//       const freeId = Number(newCart.dataset.freeId || 0);

//       if (buyIds.length > 0 && freeId) {

//         fetch('/cart.js')
//           .then(res => res.json())
//           .then(cart => {
//             const anyBuyExists = cart.items.some(i => buyIds.includes(i.variant_id));
//             const freeItem = cart.items.find(i => i.variant_id == freeId);

//             if (anyBuyExists && !freeItem) {

//               fetch('/cart/add.js', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                   id: freeId,
//                   quantity: 1
//                 })
//               })
//               .then(r => r.json())
//               .then(() => {
//                 console.log("Added free product.");
//                 load_cart();
//               });

//               return;
//             }

//             if (!anyBuyExists && freeItem) {

//               const newremoveBtn = document.querySelector(`.item-remove[data-line="${freeId}"]`);
//                     console.log(newremoveBtn);
//                     if (newremoveBtn) {
//                       removeItem(newremoveBtn.dataset.line);
//                     }
//             }

//           });
//       }
//     }

//     const newCart2 = document.querySelector('#cart');

//     if (newCart2) {

//       const buyIdsTwo = (newCart2.dataset.buyId2 || '')
//         .split(',')
//         .map(id => Number(id.trim()))
//         .filter(id => id > 0);

//       const freeIdTwo = Number(newCart2.dataset.freeId2 || 0);

//       if (buyIdsTwo.length > 0 && freeIdTwo) {

//         fetch('/cart.js')
//           .then(res => res.json())
//           .then(cart => {
//             const anyBuyExistsTwo = cart.items.some(i => buyIdsTwo.includes(i.variant_id));
//             const freeItemTwo = cart.items.find(i => i.variant_id == freeIdTwo);

//             if (anyBuyExistsTwo && !freeItemTwo) {

//               fetch('/cart/add.js', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                   id: freeIdTwo,
//                   quantity: 1
//                 })
//               })
//               .then(r => r.json())
//               .then(() => {
//                 console.log("Added free product (2).");
//                 load_cart();
//               });

//               return;
//             }

//             if (!anyBuyExistsTwo && freeItemTwo) {

//               const newremoveBtnTwo = document.querySelector(`.item-remove[data-line="${freeIdTwo}"]`);
//               console.log(newremoveBtnTwo);
//               if (newremoveBtnTwo) removeItem(newremoveBtnTwo.dataset.line);
//             }

//           });
//       }
//     }


// }
// ========================= LOAD CART =========================
function load_cart() {
  
  // Fetch Drawer HTML
  fetch(`${window.Shopify.routes.root}?section_id=cart-drawer`)
    .then(res => res.text())
    .then(responseText => {
      const cartId = "cart-drawer";
      const html = new DOMParser().parseFromString(responseText, "text/html");

      const destination = document.querySelector(".cart-sidebar");
      const source = html.getElementById(cartId);

      if (source && destination) {
        destination.innerHTML = source.innerHTML;
      }

      // Init all functional blocks
      bindRemoveItemButtons();
      initCartDrawerVisibility();
      initDiscountToggle();
      bindHeaderCartClick();
      bindDrawerCloseClick();
      initCartSlidersByDevice();
      initCartmbUpsell();
      updateCartCount();
      cartVariant();

      // Bundle + Free product logic
      handleFreeThresholdProduct();
      handleBuyXGetY();
      handleBuyXGetY_Second();

      cartDrawerUpdate();
    });
}

// =============================================================
// Remove Item Buttons
// =============================================================
function bindRemoveItemButtons() {
  document.querySelectorAll(".item-remove").forEach(btn => {
    const line = btn.dataset.line;

    btn.addEventListener("click", () => {
      removeItem(line);

      setTimeout(() => {
        const upsellWrap = document.querySelector(".cart-upsell-wrap");
        if (upsellWrap) upsellWrap.style.opacity = "1";
      }, 2000);
    });
  });
}

// =============================================================
// Drawer Visibility (empty/middle/footer)
// =============================================================
function initCartDrawerVisibility() {
  const drawerMiddle = document.querySelector(".cart-sidebar .drawer-middle");
  const drawerFooter = document.querySelector(".cart-sidebar .drawer-footer");
  const emptyDiv = document.querySelector(".cart-sidebar .empty-cart");
  const cartItems = document.querySelectorAll(".cart-sidebar .cartitems");

  const hasItems = cartItems.length > 0;

  if (drawerMiddle) drawerMiddle.style.opacity = hasItems ? "1" : "0";
  if (drawerFooter) drawerFooter.style.opacity = hasItems ? "1" : "0";
  if (emptyDiv) emptyDiv.style.opacity = hasItems ? "0" : "1";
}

// =============================================================
// Discount Accordion Toggle
// =============================================================
function initDiscountToggle() {
  document.querySelectorAll(".cart-discount-btn").forEach(btn => {
    btn.addEventListener("click", () => {
      const parent = btn.closest(".dr-stack-cart");
      if (parent) parent.classList.toggle("active");
    });
  });
}

// =============================================================
// Header Cart Button Click
// =============================================================
function bindHeaderCartClick() {
  document.querySelectorAll(".header-cart").forEach(btn => {
    btn.addEventListener("click", () => {
      const body = document.body;
      const cartDrawer = document.querySelector(".cart-sidebar");
      const upsell = document.querySelector(".cart-upsell-wrap");
      const footer = document.querySelector(".cart-sidebar .drawer-footer");
      const middle = document.querySelector(".cart-sidebar .drawer-middle");

      body.classList.add("open-drawer");
      body.classList.remove("open-menu", "open-search", "open-sort", "open-filter");
      lenis.stop();

      initCartmbUpsell();
      initCartSlidersByDevice();

      if (!cartDrawer) return;

      if (window.innerWidth > 767) {
        cartDrawer.style.maxHeight = `${window.innerHeight}px`;
        cartDrawer.style.opacity = "1";

        cartDrawer.addEventListener("transitionend", function handler(ev) {
          if (ev.propertyName === "max-height") {
            if (upsell) upsell.style.opacity = "1";
            if (footer) footer.style.opacity = "1";
            if (middle) middle.style.opacity = "1";
            cartDrawer.removeEventListener("transitionend", handler);
          }
        });
      } else {
        if (upsell) upsell.style.opacity = "1";
      }
    });
  });
}

// =============================================================
// Drawer Close
// =============================================================
function bindDrawerCloseClick() {
  document.querySelectorAll(".overlay-box, .cart-drawer-close").forEach(btn => {
    btn.addEventListener("click", () => {
      const body = document.body;
      const cartDrawer = document.querySelector(".cart-sidebar");
      const upsell = document.querySelector(".cart-upsell-wrap");
      const footer = document.querySelector(".cart-sidebar .drawer-footer");
      const middle = document.querySelector(".cart-sidebar .drawer-middle");

      body.classList.remove("open-drawer", "open-menu", "open-search", "open-sort", "open-filter");

      if (upsell) upsell.style.opacity = "0";

      lenis.start();

      if (window.innerWidth > 767 && cartDrawer) {
        cartDrawer.style.maxHeight = "0px";
        cartDrawer.style.opacity = "0";
        if (footer) footer.style.opacity = "0";
        if (middle) middle.style.opacity = "0";

        cartDrawer.addEventListener("transitionend", function handler() {
          cartDrawer.style.maxHeight = "";
          cartDrawer.style.opacity = "";
          cartDrawer.removeEventListener("transitionend", handler);
        });
      }
    });
  });
}

// =============================================================
// Init Sliders (Desktop Only)
// =============================================================
function initCartSlidersByDevice() {
  if (window.innerWidth > 767) {
    initCartSliders();
  }
}

// =============================================================
// Update Cart Count
// =============================================================
function updateCartCount() {
  fetch("/cart.js")
    .then(resp => resp.json())
    .then(data => {
      document.querySelector(".cart-count").innerHTML = data.item_count;
    })
    .catch(err => console.log(err));
}

// =============================================================
// THRESHOLD FREE PRODUCT
// =============================================================
function handleFreeThresholdProduct() {
  const cartForm = document.querySelector(".cart-iems-wrap [data-free-product]");
  if (!cartForm) return;

  const threshold = Number(cartForm.dataset.freeThreshold || 0);
  const freeProduct = Number(cartForm.dataset.freeProduct || 0);
  if (!freeProduct || !threshold) return;

  fetch("/cart.js")
    .then(res => res.json())
    .then(cart => {
      const total = cart.items_subtotal_price / 100;
      const freeItem = cart.items.find(i => i.id == freeProduct);

      // ADD FREE PRODUCT
      if (total >= threshold && !freeItem) {
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: freeProduct, quantity: 1 })
        })
          .then(r => r.json())
          .then(() => load_cart());
        return;
      }

      // REMOVE FREE PRODUCT
      if (total < threshold && freeItem) {
        const removeBtn = document.querySelector(`.item-remove[data-line="${freeProduct}"]`);
        if (removeBtn) removeItem(removeBtn.dataset.line);
      }
    });
}

// =============================================================
// BUY X GET Y (First bundle)
// =============================================================
// function handleBuyXGetY() {
//   const cart = document.querySelector("#cart");
//   if (!cart) return;

//   const buyIds = (cart.dataset.buyId || "")
//     .split(",")
//     .map(id => Number(id.trim()))
//     .filter(id => id > 0);

//   const freeId = Number(cart.dataset.freeId || 0);
//   if (!buyIds.length || !freeId) return;

//   fetch("/cart.js")
//     .then(res => res.json())
//     .then(cartData => {

//       let totalBuyQty = 0;

//       // Count total qty of all BUY products
//       cartData.items.forEach(item => {
//         if (buyIds.includes(item.variant_id)) {
//           totalBuyQty += item.quantity;
//         }
//       });

//       const freeItem = cartData.items.find(i => i.variant_id === freeId);
//       const currentFreeQty = freeItem ? freeItem.quantity : 0;

//       // -------------------------------------
//       // CASE 1: Add missing free items
//       // -------------------------------------
//       if (totalBuyQty > currentFreeQty) {
//         console.log('herere');
//         const qtyToAdd = totalBuyQty - currentFreeQty;
//         fetch("/cart/add.js", {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ id: freeId, quantity: qtyToAdd })
//         })
//           .then(r => r.json())
//           .then(() => load_cart());
//         return;
//       }

//       // -------------------------------------
//       // CASE 2: ALL buy products removed → remove ALL free products
//       // -------------------------------------
//       if (totalBuyQty === 0 && freeItem) {
//         console.log(freeItem,'herere---remove ',freeId,freeItem.line);
//         let count = freeItem.quantity;

//         const interval = setInterval(() => {
//           const btn = document.querySelector(`.item-remove[data-variant-id="${freeId}"]`);
//           if (btn) {
//             removeItem(btn.dataset.line);
//           }
//           count--;
//           if (count <= 0) clearInterval(interval);
//         }, 300);

//         return;
//       }

//       // -------------------------------------
//       // CASE 3: Reduce extra free qty (BUY qty < FREE qty)
//       // -------------------------------------
//       if (totalBuyQty < currentFreeQty) {
//         let toRemove = currentFreeQty - totalBuyQty;

//         const interval = setInterval(() => {
//           const btn = document.querySelector(`.item-remove[data-line="${freeItem.line}"]`);
//           if (btn) {
//             removeItem(btn.dataset.line);
//           }
//           toRemove--;
//           if (toRemove <= 0) clearInterval(interval);
//         }, 300);
//       }

//     });
// }
let bxgyLock = false;

function handleBuyXGetY() {
  if (bxgyLock) return;
  bxgyLock = true;

  setTimeout(() => {

    const cart = document.querySelector("#cart");
    if (!cart) {
      bxgyLock = false;
      return;
    }

    const buyIds = (cart.dataset.buyId || "")
      .split(",")
      .map(id => Number(id.trim()))
      .filter(id => id > 0);

    const freeId = Number(cart.dataset.freeId || 0);

    if (!buyIds.length || !freeId) {
      bxgyLock = false;
      return;
    }

    fetch("/cart.js")
      .then(res => res.json())
      .then(async cartData => {

        // 1️⃣ COUNT BUY ITEMS
        let totalBuyQty = 0;
        cartData.items.forEach(item => {
          if (buyIds.includes(item.variant_id)) {
            totalBuyQty += item.quantity;
          }
        });

        // 2️⃣ COLLECT ALL FREE LINES
        let freeLines = cartData.items
          .map((item, index) => ({
            variant_id: item.variant_id,
            quantity: item.quantity,
            line: index + 1
          }))
          .filter(i => i.variant_id === freeId);

        let currentFreeQty = freeLines.reduce((sum, i) => sum + i.quantity, 0);


        // 3️⃣ ADD MISSING FREE PRODUCTS
        if (totalBuyQty > currentFreeQty) {
          const qtyToAdd = totalBuyQty - currentFreeQty;

          await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: freeId, quantity: qtyToAdd })
          });

          bxgyLock = false;
          load_cart();
          return;
        }


        // 4️⃣ REMOVE ALL FREE IF BUY = 0
        if (totalBuyQty === 0 && currentFreeQty > 0) {

          for (let f of freeLines) {
            await fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ line: f.line, quantity: 0 })
            });
          }

          bxgyLock = false;
          load_cart();
          return;
        }


        // 5️⃣ REMOVE EXTRA FREE ITEMS
        if (totalBuyQty < currentFreeQty) {
          let toRemove = currentFreeQty - totalBuyQty;

          while (toRemove > 0) {

            // Always re-fetch so line numbers are accurate
            let cartNow = await fetch("/cart.js").then(r => r.json());

            // get fresh free lines
            let freshFreeLines = cartNow.items
              .map((item, index) => ({
                variant_id: item.variant_id,
                line: index + 1,
                quantity: item.quantity
              }))
              .filter(i => i.variant_id === freeId)
              .reverse(); // remove last first

            let f = freshFreeLines[0];
            if (!f) break;

            let removeNow = Math.min(f.quantity, toRemove);

            await fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                line: f.line,
                quantity: f.quantity - removeNow
              })
            });

            toRemove -= removeNow;
          }

          bxgyLock = false;
          load_cart();
          return;
        }

        bxgyLock = false;
      });
  }, 150);
}

// function handleBuyXGetY() {
//   const cart = document.querySelector("#cart");
//   if (!cart) return;

//   const buyIds = (cart.dataset.buyId || "")
//     .split(",")
//     .map(id => Number(id.trim()))
//     .filter(id => id > 0);

//   const freeId = Number(cart.dataset.freeId || 0);
//   if (!buyIds.length || !freeId) return;

//   fetch("/cart.js")
//     .then(res => res.json())
//     .then(cartData => {
//       const anyBuyExists = cartData.items.some(i => buyIds.includes(i.variant_id));
//       const freeItem = cartData.items.find(i => i.variant_id == freeId);

//       if (anyBuyExists && !freeItem) {
//         fetch("/cart/add.js", {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ id: freeId, quantity: 1 })
//         })
//           .then(r => r.json())
//           .then(() => load_cart());
//         return;
//       }

//       if (!anyBuyExists && freeItem) {
//         const btn = document.querySelector(`.item-remove[data-line="${freeId}"]`);
//         if (btn) removeItem(btn.dataset.line);
//       }
//     });
// }

// =============================================================
// BUY X GET Y (Second bundle)
// =============================================================
let bxgyLock_second = false;

function handleBuyXGetY_Second() {
  if (bxgyLock_second) return;
  bxgyLock_second = true;

  setTimeout(() => {

    const cart = document.querySelector("#cart");
    if (!cart) {
      bxgyLock_second = false;
      return;
    }

    const buyIds = (cart.dataset.buyId2 || "")
      .split(",")
      .map(id => Number(id.trim()))
      .filter(id => id > 0);

    const freeId = Number(cart.dataset.freeId2 || 0);

    if (!buyIds.length || !freeId) {
      bxgyLock_second = false;
      return;
    }

    fetch("/cart.js")
      .then(res => res.json())
      .then(async cartData => {

        // 1️⃣ COUNT BUY ITEMS
        let totalBuyQty = 0;
        cartData.items.forEach(item => {
          if (buyIds.includes(item.variant_id)) {
            totalBuyQty += item.quantity;
          }
        });

        // 2️⃣ COLLECT ALL FREE LINES
        let freeLines = cartData.items
          .map((item, index) => ({
            variant_id: item.variant_id,
            quantity: item.quantity,
            line: index + 1
          }))
          .filter(i => i.variant_id === freeId);

        let currentFreeQty = freeLines.reduce((sum, i) => sum + i.quantity, 0);


        // 3️⃣ ADD MISSING FREE PRODUCTS
        if (totalBuyQty > currentFreeQty) {
          const qtyToAdd = totalBuyQty - currentFreeQty;

          await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: freeId, quantity: qtyToAdd })
          });

          bxgyLock_second = false;
          load_cart();
          return;
        }


        // 4️⃣ REMOVE ALL FREE IF BUY = 0
        if (totalBuyQty === 0 && currentFreeQty > 0) {

          for (let f of freeLines) {
            await fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ line: f.line, quantity: 0 })
            });
          }

          bxgyLock_second = false;
          load_cart();
          return;
        }


        // 5️⃣ REMOVE EXTRA FREE ITEMS
        if (totalBuyQty < currentFreeQty) {
          let toRemove = currentFreeQty - totalBuyQty;

          while (toRemove > 0) {

            // Always re-fetch so line numbers are accurate
            let cartNow = await fetch("/cart.js").then(r => r.json());

            // get fresh free lines
            let freshFreeLines = cartNow.items
              .map((item, index) => ({
                variant_id: item.variant_id,
                line: index + 1,
                quantity: item.quantity
              }))
              .filter(i => i.variant_id === freeId)
              .reverse(); // remove last first

            let f = freshFreeLines[0];
            if (!f) break;

            let removeNow = Math.min(f.quantity, toRemove);

            await fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                line: f.line,
                quantity: f.quantity - removeNow
              })
            });

            toRemove -= removeNow;
          }

          bxgyLock_second = false;
          load_cart();
          return;
        }

        bxgyLock_second = false;
      });
  }, 150);
}
// function handleBuyXGetY_Second() {
//   const cart = document.querySelector("#cart");
//   if (!cart) return;

//   const buyIds = (cart.dataset.buyId2 || "")
//     .split(",")
//     .map(id => Number(id.trim()))
//     .filter(id => id > 0);

//   const freeId = Number(cart.dataset.freeId2 || 0);
//   if (!buyIds.length || !freeId) return;

//   fetch("/cart.js")
//     .then(res => res.json())
//     .then(cartData => {
//       const anyBuyExists = cartData.items.some(i => buyIds.includes(i.variant_id));
//       const freeItem = cartData.items.find(i => i.variant_id == freeId);

//       if (anyBuyExists && !freeItem) {
//         fetch("/cart/add.js", {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ id: freeId, quantity: 1 })
//         })
//           .then(r => r.json())
//           .then(() => load_cart());
//         return;
//       }

//       if (!anyBuyExists && freeItem) {
//         const btn = document.querySelector(`.item-remove[data-line="${freeId}"]`);
//         if (btn) removeItem(btn.dataset.line);
//       }
//     });
// }

function cartDrawerUpdate() {
    var url = window.location.href;
    fetch(url)
    .then(response => response.text())
    .then(html => {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      if (doc.querySelector('.section-cart') != null) {
      var mainSectionContent = doc.querySelector('.section-cart').innerHTML;
      document.querySelector('.section-cart').innerHTML = mainSectionContent;
      cartVariant();
      }

    })
    .catch(error => {
      console.error('Error fetching collection main section:', error);
    });
  }

// ------------------ REMOVE ITEM ------------------
function removeItem(data_line) {
  const data = { line: data_line, quantity: 0 };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  })
    .then(() => load_cart())
    .catch((error) => console.error('Error:', error));
}

// ------------------ UPDATE ITEM ------------------
function updateItem(data_line, data_qty) {
  const data = { line: data_line, quantity: data_qty };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  })
    .then(() => {
      if (document.location.href.indexOf('/cart') > -1) {
        load_cart();
      } else {
        load_cart();
        setTimeout(() => document.querySelector('body').classList.add('open-drawer'), 500);
      }
    })
    .catch((error) => console.error('Error:', error));
}

// ------------------ CART VARIANT FUNCTIONS ------------------
function cartVariant() {
  // Plus
  document.querySelectorAll('.ci_plus a').forEach((plus) => {
    plus.addEventListener('click', function (e) {
      e.preventDefault(); e.stopImmediatePropagation();
      const input = plus.closest('.ci_qtybox').querySelector('.cart_qty');
      input.value = parseInt(input.value) + 1;
      const new_line = this.getAttribute('data-line-item');
      const new_qty = input.value;
      updateItem(new_line, new_qty);
      console.log(new_qty);
    });
  });

  // Minus
  document.querySelectorAll('.ci_minus a').forEach((minus) => {
    minus.addEventListener('click', function (e) {
      e.preventDefault(); e.stopImmediatePropagation();
      const input = minus.closest('.ci_qtybox').querySelector('.cart_qty');
      const currentQty = parseInt(input.value);
      const minQty = parseInt(input.getAttribute('min')) || 1;
      if (currentQty > minQty) {
        input.value = currentQty - 1;
        const newLine = this.getAttribute('data-line-item');
        const newQty = input.value;
        updateItem(newLine, newQty);
      }
    });
  });

  // Variant change
  // document.querySelectorAll('.cd_variant').forEach((cdVariantAdd) => {
  //   cdVariantAdd.addEventListener('click', function (e) {
  //     e.preventDefault(); e.stopImmediatePropagation();
  //     cdVariantAdd.closest('.cd_variant_cls').classList.remove('active');
  //     const cart_error = cdVariantAdd.closest('.cartitems').querySelector('.cierror');
  //     const currentid = cdVariantAdd.closest('.cartitems').querySelector('.item-remove').getAttribute('data-line');
  //     const changevar_id = cdVariantAdd.getAttribute('data-id');
  //     const item_current_qty = cdVariantAdd.closest('.cartitems').querySelector('.cart_qty').value;
  //     const formData = { items: [{ id: changevar_id, quantity: item_current_qty }] };

  //     fetch('/cart/add.js', {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify(formData),
  //     })
  //       .then(() => setTimeout(() => updateItem(currentid, 0), 500))
  //       .catch((error) => {
  //         console.error('error', error);
  //         if(cart_error) { cart_error.textContent = 'Error'; setTimeout(() => cart_error.textContent = '', 2000); }
  //       });
  //   });
  // });

  // // Variant open/close toggle
  // const cdVariantBox = document.querySelectorAll('.cd_variant_cls');
  // cdVariantBox.forEach((variantBox) => {
  //   const btn = variantBox.querySelector('.cd_variantbtn');
  //   if (btn) btn.addEventListener('click', (e) => {
  //     e.preventDefault(); e.stopImmediatePropagation();
  //     cdVariantBox.forEach((box) => { if (box !== variantBox) box.classList.remove('active'); });
  //     variantBox.classList.toggle('active');
  //   });
  // });
  document.querySelectorAll('.cd_variant').forEach((cdVariantAdd) => {
    cdVariantAdd.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const variantCls = cdVariantAdd.closest('.cd_variant_cls');
      const variantList = variantCls.querySelector('.cd__variant_list');

      variantCls.classList.remove('active');
      if (variantList) variantList.style.maxHeight = "0px";

      const cart_error = cdVariantAdd.closest('.cartitems').querySelector('.cierror');
      const currentid = cdVariantAdd.closest('.cartitems').querySelector('.item-remove').getAttribute('data-line');
      const changevar_id = cdVariantAdd.getAttribute('data-id');
      const item_current_qty = cdVariantAdd.closest('.cartitems').querySelector('.cart_qty').value;

      const formData = { items: [{ id: changevar_id, quantity: item_current_qty }] };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      })
        .then(() => setTimeout(() => updateItem(currentid, 0), 500))
        .catch((error) => {
          console.error('error', error);
          if (cart_error) {
            cart_error.textContent = 'Error';
            setTimeout(() => (cart_error.textContent = ''), 2000);
          }
        });
    });
  });

  if (document.querySelectorAll('.drawer-btm-wrap').length) {
    document.querySelectorAll('.drawer-btm-wrap').forEach(drawerWrap => {
      let accoHeads = drawerWrap.querySelectorAll('.cart-acco-head');
      let accoWrapper = drawerWrap.querySelector('.cart-acco-wrapper');
      let accoContents = drawerWrap.querySelectorAll('.cart-acco-cont');
      let drawerMiddle = document.querySelector('.drawer-middle'); // global scroll area
      let closeBtn = drawerWrap.querySelector('.cart-acc-close a');

      if (!accoWrapper || !accoHeads.length) return;

      // ✅ Set default height (on load) — same logic as click
      let activeCont = drawerWrap.querySelector('.cart-acco-cont.active-content');
      if (activeCont) {
        let ul = activeCont.querySelector('ul');
        let contentHeight = ul ? ul.offsetHeight : 0;

        let contentMaxHeight =
          document.querySelector('.drawer-middle').offsetHeight -
          (document.querySelector('.center-drawer-header').offsetHeight +
          document.querySelector('.cart_slider_wrapper').offsetHeight +
          drawerWrap.querySelector('.cart-mbottom').offsetHeight);

        let finalHeight = Math.max(contentMaxHeight, contentHeight);
        accoWrapper.style.maxHeight = `${finalHeight}px`;
      } else {
        accoWrapper.style.maxHeight = '0';
      }

      // ✅ Accordion click logic
      accoHeads.forEach(head => {
        head.addEventListener('click', e => {
          e.preventDefault();

          let val = head.dataset.val;
          let content = drawerWrap.querySelector(`.cart-acco-cont[data-val="${val}"]`);
          let accoItem = head.closest('.cart-acco');
          let isOpen = accoItem.classList.contains('active');

          // Reset all
          drawerWrap.querySelectorAll('.cart-acco').forEach(a => a.classList.remove('active'));
          accoContents.forEach(c => c.classList.remove('active-content'));

          if (!isOpen) {
            accoItem.classList.add('active');
            content.classList.add('active-content');

            // Calculate height same way
            let contentMaxHeight =
              document.querySelector('.drawer-middle').offsetHeight -
              (document.querySelector('.center-drawer-header').offsetHeight +
              document.querySelector('.cart_slider_wrapper').offsetHeight +
              drawerWrap.querySelector('.cart-mbottom').offsetHeight);

            let ul = content.querySelector('ul');
            let contentHeight = ul ? ul.offsetHeight : 0;

            let finalHeight = Math.max(contentMaxHeight, contentHeight);
            accoWrapper.style.maxHeight = `${finalHeight}px`;

            // ✅ Add open-cart-acco only on mobile
            if (window.innerWidth <= 768) {
              accoWrapper.classList.add('open-cart-acco');
            }

            // Smooth scroll to bottom
            if (drawerMiddle) {
              drawerMiddle.scrollTo({
                top: drawerMiddle.scrollHeight,
                behavior: 'smooth'
              });
            }
          } else {
            accoWrapper.style.maxHeight = '0';
            accoWrapper.classList.remove('open-cart-acco');
          }
        });
      });

      // ✅ Close button logic
      if (closeBtn) {
        closeBtn.addEventListener('click', e => {
          e.preventDefault();

          drawerWrap.querySelectorAll('.cart-acco').forEach(a => a.classList.remove('active'));
          accoContents.forEach(c => c.classList.remove('active-content'));
          accoWrapper.style.maxHeight = '0';
          accoWrapper.classList.remove('open-cart-acco');
        });
      }
    });
  }




  // Variant open/close toggle with scroll height effect on .cd__variant_list
  const cdVariantBox = document.querySelectorAll('.cd_variant_cls');
  cdVariantBox.forEach((variantBox) => {
    const btn = variantBox.querySelector('.cd_variantbtn');
    const variantList = variantBox.querySelector('.cd__variant_list');

    if (btn && variantList) {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();

        cdVariantBox.forEach((box) => {
          const innerList = box.querySelector('.cd__variant_list');
          if (box !== variantBox) {
            box.classList.remove('active');
            if (innerList) innerList.style.maxHeight = "0px";
          }
        });

        // Toggle current
        const isActive = variantBox.classList.toggle('active');
        if (isActive) {
          variantList.style.maxHeight = variantList.scrollHeight + "px";
        } else {
          variantList.style.maxHeight = "0px";
        }
      });
    }
  });

}

document.addEventListener('click', function (event) {
  if (event.target.closest('.quick-add-to-cart')) {
    const addToCartBtn = event.target.closest('.quick-add-to-cart');
    const line = addToCartBtn.getAttribute('data-id');
    if (!line) return;

    const title = addToCartBtn.getAttribute('data-pro-title') || '';
    const imgSrc = addToCartBtn.getAttribute('data-img-src') || '';

    // Elements for popup
    const cartPopup = document.getElementById('cart-popup');
    const popupTitle = document.getElementById('cart-popup-title');
    const popupImage = document.getElementById('cart-popup-image');
    const popupClose = document.querySelector('.cart-popup-close');

    let popupTimer;

    const data = { items: [{ id: line, quantity: 1 }] };
    console.log('data--',data);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then(() => {
        // If user is on the cart page, refresh it
        if (window.location.pathname.includes('/cart')) {
          window.location.reload();
          return;
        }

        // Update cart drawer or mini-cart
        if (typeof load_cart === 'function') load_cart();

        // Show cart popup
        popupTitle.textContent = title;
        popupImage.src = imgSrc;

        cartPopup.classList.remove('hidden');
        cartPopup.classList.add('visible');

        clearTimeout(popupTimer);
        popupTimer = setTimeout(() => {
          cartPopup.classList.remove('visible');
          setTimeout(() => cartPopup.classList.add('hidden'), 300);
        }, 3000);
      })
      .catch((error) => console.error('Error:', error));

    // Allow manual close (attach once)
    if (popupClose && !popupClose.hasListener) {
      popupClose.addEventListener('click', function () {
        clearTimeout(popupTimer);
        cartPopup.classList.remove('visible');
        setTimeout(() => cartPopup.classList.add('hidden'), 300);
      });
      popupClose.hasListener = true;
    }
  }
});




const drawer = document.querySelector('.cart-sidebar');

drawer.addEventListener('wheel', (e) => {
  e.stopPropagation();
}, { passive: false });

drawer.addEventListener('touchstart', (e) => {
  e.stopPropagation();
}, { passive: false });

drawer.addEventListener('touchmove', (e) => {
  e.stopPropagation();
}, { passive: false });

if (window.innerWidth < 767) {
 const mobileinner = document.querySelector('.cart-sidebar #cart');
  if (mobileinner){
    mobileinner.addEventListener('wheel', (e) => {
      e.stopPropagation();
    }, { passive: false });

    mobileinner.addEventListener('touchstart', (e) => {
      e.stopPropagation();
    }, { passive: false });

    mobileinner.addEventListener('touchmove', (e) => {
      e.stopPropagation();
    }, { passive: false });
 }

}



// ------------------ SWIPER INITS ------------------
// function initSearchRowSwipers() {
//   console.log("innnnnnnnnnnnnn");
//   document.querySelectorAll('.emtycart_slider').forEach((searchRow) => {
//     if (searchRow.classList.contains('swiper-initialized')) return;
//     new Swiper(searchRow, { slidesPerView: 2.3, spaceBetween: 1, loop: false, freeMode: true, watchOverflow: true });
//   });
// }
function initSearchRowSwipers() {
  setTimeout(() => {
    document.querySelectorAll('.emtycart_slider').forEach((searchRow) => {      
      if (searchRow.classList.contains('swiper-initialized')) return;
      new Swiper(searchRow, { 
        slidesPerView: 2.1, 
        spaceBetween: 1, 
        loop: false, 
        freeMode: true, 
        watchOverflow: true 
      });
    });
  },2000);
}


function initCartmbUpsell() {
  document.querySelectorAll('.cart_upsell_wrap').forEach((slider) => {
    if (slider.classList.contains('swiper-initialized')) return;
    new Swiper(slider, {
      slidesPerView: 2.3, spaceBetween: 1, loop: false, freeMode: true, watchOverflow: true,preventClicks: false,preventClicksPropagation: false,
      mousewheel: { forceToAxis: true, releaseOnEdges: true, sensitivity: 1, thresholdDelta: 1, thresholdTime: 200 }
    });
  });
}

function initCartSliders() {
  document.querySelectorAll('.cart-slider').forEach((slider) => {
    if (slider.classList.contains('swiper-initialized')) return;
    new Swiper(slider, {
      slidesPerView: 3.3, spaceBetween: 1, loop: false, watchOverflow: true, freeMode: true,
      mousewheel: { forceToAxis: true, releaseOnEdges: true, sensitivity: 1, thresholdDelta: 1, thresholdTime: 200 },
      navigation: { nextEl: '.cdh-buttons .swiper-button-next', prevEl: '.cdh-buttons .swiper-button-prev' },
    });
  });
}

// ------------------ INIT ON DOM ------------------
document.addEventListener('DOMContentLoaded', () => {
  initCartSliders();
  initCartmbUpsell();
  if (window.innerWidth < 767) {
    initSearchRowSwipers();
  }
});
if (window.innerWidth < 767) {
initSearchRowSwipers();
}
// ------------------ RESIZE HANDLER ------------------
window.resizeTimeout = window.resizeTimeout || null;

window.addEventListener('resize', () => {
  clearTimeout(window.resizeTimeout);
  window.resizeTimeout = setTimeout(() => {
    initCartmbUpsell();
    if (window.innerWidth > 767) {
      initCartSliders();
    } else {
      initSearchRowSwipers();
    }
  }, 250);
});


// ------------------ LOAD INITIAL CART ------------------
load_cart();